// extracted by mini-css-extract-plugin
export default {"mCard":"bF-z","image":"cF-z","imageNoBackground":"dF-z","imageHasCategory":"eF-z","fullWidth":"fF-z"};